// extracted by mini-css-extract-plugin
export default {"questions_page_Container":"createQuizPage_questions_page_Container__DoWyT"};